import React from "react";
import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import { objectives } from "../mock";

const Objectives = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-slate-50 to-white relative overflow-hidden">
      {/* Decorative circles */}
      <div className="absolute -top-20 -left-20 w-80 h-80 rounded-full bg-green-100/40 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-20 -right-20 w-80 h-80 rounded-full bg-blue-100/40 blur-3xl pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-12 items-start relative">
        <div>
          <p className="text-green-600 font-semibold tracking-widest text-sm uppercase mb-3">
            Driving Excellence
          </p>
          <h2 className="text-3xl md:text-5xl font-black text-slate-900 leading-tight mb-6">
            Our <span className="text-green-600">Objectives</span>
          </h2>
          <p className="text-slate-600 leading-relaxed mb-8">
            We are committed to delivering universal basic education that empowers
            every Akwa Ibom child to dream, learn, and lead with confidence.
          </p>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 text-[#0a2463] font-bold border-b-2 border-[#0a2463] pb-1 hover:gap-3 transition-all"
          >
            Learn more about us <ArrowRight size={18} />
          </Link>
        </div>

        <ul className="space-y-4">
          {objectives.map((obj) => (
            <li
              key={obj.slice(0, 40)}
              className="flex gap-4 p-5 bg-white border-l-4 border-green-600 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all"
            >
              <div className="flex-shrink-0 w-9 h-9 rounded-full bg-green-600 text-white flex items-center justify-center font-bold">
                <Check size={18} />
              </div>
              <p className="text-slate-700 leading-relaxed pt-1">{obj}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default Objectives;
